<template>
    <div class="checkbox-wrapper" :class="{'disable':disable}">
        <input type="checkbox" :checked="isChecked" @change="change()" :required="required" ref="input_checkbox"/>
        <div class="custom-checkbox" @click="change()">{{ isChecked ? '&#10004;'	 : '' }}</div><span v-if="label"  @click="change()">{{ label }}</span>
    </div>
</template>
<script>
export default {
	props: {
		value: {
			type: Boolean,
			default: false
		},

		label: {
			type: String,
			default: null
		},

		disable: {
			type: Boolean,
			default: false
		},

		required: {
			type: Boolean,
			default: false
		}
	},

	watch: {
		value (val) {
			this.isChecked = val
		}
	},

	data () {
		return {
			isChecked: this.value
		}
	},

	methods: {
		change () {
			this.isChecked = !this.isChecked
			this.$emit('input', this.isChecked)
		}
	}
}
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
    display: flex;
    align-items: center;
    position: relative;

    input[type=checkbox]{
        position: absolute;
        opacity: 0;
        top: 0;
        cursor: pointer;
    }

    .custom-checkbox {
        height: 1.8vw;
        width: 1.8vw;
        padding: 0.2vw;
        border: 2px solid #E5E8EB;
        background-color: #fff;
        border-radius: 4px;
        position: relative;
        display:flex;
        align-items: center;
        justify-content: center;
        color: #2DC4B6;
        user-select: none;
        cursor: pointer;
        flex-shrink: 0;

        &:hover {
            box-shadow: 0 0 2px #808495;
        }

    }

    &.disable {
        pointer-events: none;
    }

    span {
        display: inline-block;
        margin-left: 15px;
        flex: 1 1 auto;
        user-select: none;
        cursor: pointer;
    }
}
</style>
